<template>
    <!-- 立即兑换 -->
    <div>
        <el-card shadow="never" class="invoice_card">
            <div slot="header" class="title-box">
                <el-button type="primary" class="backBtn" @click="changeBack">返回</el-button>
                <span style="font-size: 20px; font-weight: 600; color: #192e4d">信息填写</span>
            </div>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <div style="margin-bottom: 20px">
                    <div class="desciconLarge" style="background-color: #fda533"></div>
                    <span class="font18">个人信息</span>
                </div>
                <el-form-item label="联系人" prop="contacts">
                    <el-input v-model="form.contacts" placeholder="请输入联系人" style="width: 460px"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phoneNumber">
                    <el-input v-model="form.phoneNumber" placeholder="请输入联系电话" style="width: 460px"></el-input>
                </el-form-item>
                <el-form-item label="所在省市" prop="provinceValue">
                    <el-cascader placeholder="请选择所在省市" style="width: 460px" :options="regionData" @change="handleChange" v-model="form.provinceValue"></el-cascader>
                </el-form-item>
                <el-form-item label="寄送地址" prop="address">
                    <el-input v-model="form.address" type="textarea" maxlength="200" show-word-limit placeholder="请输入寄送地址" style="width: 460px"></el-input>
                </el-form-item>
                <el-form-item label="兑换备注" prop="favRemark">
                    <el-input type="textarea" maxlength="200" :rows="4" show-word-limit v-model="form.favRemark" placeholder="请输入兑换备注"></el-input>
                </el-form-item>
                <div class="exchange_info">
                    <div class="table_head">
                        <div class="table_head_col" :style="{ width: i.width }" v-for="i in headList" :key="i.index">{{ i.name }}</div>
                    </div>
                    <div class="table_divider" />
                    <div class="table_head" style="color: #734116; font-size: 16px">
                        <div style="width: 200px; display: flex; align-items: center">
                            <el-image :src="intergraForm.imgUrl" class="intergraInfoImg">
                                <div slot="error">
                                    <img class="intergraInfoImg" src="@/assets/img/morentupian.png" />
                                </div>
                            </el-image>
                            <div style="margin-left: 10px; display: flex; flex: 1">{{ intergraForm.mallName }}</div>
                        </div>
                        <div style="width: 100px">1</div>
                        <div style="width: 100px">
                            <div>{{ intergraForm.number }}</div>
                        </div>
                        <div style="width: 200px; color: #ff0000">
                            <div>{{ intergraForm.remark }}</div>
                        </div>
                    </div>
                </div>
            </el-form>
            <div style="margin-top: 100px" />
            <el-card style="background-color: #fff8f2">
                <div class="submitBox">
                    <div style="font-size: 16px; color: #333333; font-weight: bold; display: flex; align-items: center">
                        合计:
                        <span class="redeemPoints">{{ intergraForm.redeemPoints }}</span>
                    </div>
                    <div style="display: flex; align-items: center">
                        <span class="pointBalance">
                            当前可用积分:
                            <span style="color: #ff0000">{{ moneyInfo.pointBalance || 0 }}</span>
                        </span>
                        <el-button @click="handleSubmit()" type="primary" v-preventClick class="submitBtn">提交</el-button>
                    </div>
                </div>
            </el-card>
        </el-card>
        <!-- 积分兑换确认弹窗-->
        <exchangeConfirmDlg ref="exchangeConfirmDlgRef" @confirm="confirmExchange"></exchangeConfirmDlg>
    </div>
</template>

<script>
import { regionData, codeToText } from 'element-china-area-data';
import { exchangePointsClient } from '@/api/request';
import { isMobile } from '@/plugins/validate';
import exchangeConfirmDlg from './exchangeConfirmDlg';
export default {
    name: 'redeemNow',
    components: {
        exchangeConfirmDlg
    },
    data() {
        var validateMobile = (rule, value, callback) => {
            if (value && !isMobile(value)) {
                return callback(new Error('请输入正确的手机号'));
            }
            callback();
        };
        return {
            regionData,
            moneyInfo: {},
            intergraForm: {
                imgUrl: ''
            },
            imgurl: process.env.VUE_APP_FILE_API,
            form: {
                mallId: '',
                contacts: '',
                phoneNumber: '',
                favRemark: '',
                address: '',
                provinceValue: [],
                provinceCode: '',
                area: ''
            },
            headList: [
                { name: '礼品名称', index: 1, width: '200px' },
                { name: '兑换数量', index: 2, width: '100px' },
                { name: '单价(积分)', index: 3, width: '100px' },
                { name: '礼品描述', index: 4, width: '200px' }
            ],
            rules: {
                contacts: [
                    { required: true, trigger: 'blur', message: '请输入联系人' },
                    { max: 20, message: '联系人不能超过20个字', trigger: 'blur' }
                ],
                phoneNumber: [
                    { required: true, trigger: 'blur', message: '请输入联系电话' },
                    { validator: validateMobile, trigger: 'blur' }
                ],
                provinceValue: [{ required: true, trigger: 'blur', message: '请选择所在省市' }],
                address: [
                    { required: true, trigger: 'blur', message: '请输入寄送地址' },
                    { max: 200, message: '寄送地址不能超过200个字', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        handleChange(value) {
            this.form.provinceValue = value;
            this.form.provinceCode = value.toString();
            this.form.area = this.getCodeToText(value);
        },
        //把区域码转成汉字
        getCodeToText(value) {
            var name = '';
            value.map((item) => (name += codeToText[item] + '/'));
            return name;
        },
        init(info, moneyInfo, clientId) {
            this.$nextTick(() => {
                this.moneyInfo = moneyInfo;
                this.intergraForm = info;
                this.form.mallId = info.mallId;
                this.intergraForm.imgUrl = info.pcPic || '';
            });
        },
        changeBack() {
            this.$emit('back');
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$refs.exchangeConfirmDlgRef.publicOpen(this.intergraForm);
                }
            });
        },
        confirmExchange() {
            console.log(this.form);
            exchangePointsClient(this.form)
                .then((res) => {
                    this.$message.success('提交成功');
                    this.changeBack();
                    document.documentElement.scrollTop = 0;
                })
                .catch((err) => {
                    // console.log(err);
                    this.$message.error(err);
                    this.changeBack();
                    document.documentElement.scrollTop = 0;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.invoice_card {
    ::v-deep .el-card__header {
        border-bottom: 1px dashed #fda533;
    }
}
.exchange_info {
    background-color: #fff8f2;
}
.table_head {
    display: flex;
    flex-flow: row nowrap;
    text-align: center;
    justify-content: space-around;
    align-items: center;
    border-radius: 7px;
    color: #333;
    font-weight: 500;
    font-size: 16px;
    padding: 20px;
}
.table_divider {
    width: 90%;
    height: 0px;
    border: 1px solid #ffbd8f;
    margin: 0 auto;
}
.table_head_col {
    color: #383838;
    fosnt-size: 16px;
    font-weight: bold;
}
.table_body {
    display: flex;
    flex-flow: row nowrap;
}
.redeemPoints {
    font-weight: 500;
    font-size: 20px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 10px;
    line-height: 1;
}
.intergraInfoImg {
    width: 77px;
    height: 77px;
    border-radius: 5px;
}
.pointBalance {
    color: #333;
    font-weight: 600;
    font-size: 20px;
    margin-right: 20px;
    line-height: 1;
}
.submitBox {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
}
.title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}
.backBtn {
    color: #fff;
    background-color: #fda533;
    border: none;
    padding: 5px 20px !important;
    position: absolute;
    top: 5px;
    left: 0px;
}
.submitBtn {
    background: linear-gradient(180deg, #fe944a 0%, #f87315 100%);
    border: none;
    width: 120px;
}
</style>
